'use strict';
import angular from 'angular';
import facebookAudienceHtmlUrl from './views/facebookAudienceList.html';
import fbChildDataHtmlUrl from './views/fbRecursiveTemplate.html';
var app = angular.module('app.facebookAudience.component', []);

app.component('facebookAudienceTargeting', {
    bindings: {
        showActions: '=',
        selectedFbAudience: '=',
        clusterId: '=',
        isFormEdit: '=',
        clientId:'='
    },
    templateUrl: facebookAudienceHtmlUrl,

    // The controller that handles our component logic
    controller: function(ProductService) {
        var self = this;
  
        self.inMarketSearch = "";
        self.reMarketSearch = "";
        self.intrestsList = [];
        self.demographicsList = [];
        self.behaviourList = [];
        self.fbChildDataHtmlUrl = fbChildDataHtmlUrl;

        self.IsChildObjectVisible = function(parent, child){
            var searchKey = $scope.search;
            var returnVal = true;
            if(undefined != searchKey && null != searchKey && searchKey.length > 0){
                returnVal = ((child.name.toLowerCase().indexOf(searchKey.toLowerCase()) > -1) ||
                    (parent.name.toLowerCase().indexOf(searchKey.toLowerCase()) > -1));
            }
            return returnVal;
        }

        self.handleSelectSubChild = function (item, child, selectedFbAudience,indx,type) {
            if(type == "Demographics"){
                if (child.isChecked) {
                    child.status = '';
                    child.isChecked = false;
                    var selIndex = selectedFbAudience.demographics.indexOf(child);
                    var selIndex = _.findIndex(selectedFbAudience.demographics, { id: child.id });
                    if (selIndex >= 0) {
                        selectedFbAudience.demographics.splice(selIndex, 1);
                     } 
                } else {
                    child.status = 'selected';
                    child.isChecked = true;
                    selectedFbAudience.demographics.push(child);
                }
            } else if(type == "Interests"){
                if (child.isChecked) {
                    child.status = '';
                    child.isChecked = false;
                    var selIndex = selectedFbAudience.intrests.indexOf(child);
                    var selIndex = _.findIndex(selectedFbAudience.intrests, { id: child.id });
                    if (selIndex >= 0) {
                        selectedFbAudience.intrests.splice(selIndex, 1);
                    } 
                } else {
                    child.status = 'selected';
                    child.isChecked = true;
                    selectedFbAudience.intrests.push(child);
                }
            } else if(type == "Behaviours"){
                if (child.isChecked) {
                    child.status = '';
                    child.isChecked = false;
                    var selIndex = selectedFbAudience.behaviours.indexOf(child);
                    var selIndex = _.findIndex(selectedFbAudience.behaviours, { id: child.id });
                    if (selIndex >= 0) {
                        selectedFbAudience.behaviours.splice(selIndex, 1);
                    } 
                } else {
                    child.status = 'selected';
                    child.isChecked = true;
                    selectedFbAudience.behaviours.push(child);
                }
            }
        }

        self.addOverlap = function(data){
            data.overLapEnabled = false;
            data.excludeEnabled = false;
            if(data.excludeAdded){
                self.hideExclude = true;
            }
            var excluded_index = _.findIndex(self.selectedFbAudience, { excludeAdded: true });
            if(excluded_index >=0){
                var exclude_data = self.selectedFbAudience[excluded_index];
                self.selectedFbAudience.splice(excluded_index,1);
            }
            self.selectedFbAudience.push({intrests: [],
                behaviours: [],
                demographics:[],
                overLapEnabled:true,
                overLapAdded: true ,
                excludeEnabled:self.hideExclude ? false :true,
                behaviourList:angular.copy(self.behaviourList),
                demographicsList:angular.copy(self.demographicsList),
                intrestsList:angular.copy(self.intrestsList)
             });
             if(exclude_data){
                self.selectedFbAudience.push(exclude_data);
             }
        }

        self.excludeAudience = function(data){
            data.overLapEnabled = false;
            data.excludeEnabled = false;
            self.selectedFbAudience.push({intrests: [],
                behaviours: [],
                demographics:[],
                overLapEnabled:true,
                overLapAdded:false,
                excludeAdded:true,
                excludeEnabled:false,
                behaviourList:angular.copy(self.behaviourList),
                demographicsList:angular.copy(self.demographicsList),
                intrestsList:angular.copy(self.intrestsList)
            });
        }

        self.removeAudienceSet = function(data,index){
            if (self.selectedFbAudience.length == index + 1) {
                self.selectedFbAudience.splice(index, 1);
                var selIndex = index - 1;
                if (selIndex >= 0) {
                    self.selectedFbAudience[selIndex].excludeEnabled = true;
                    self.selectedFbAudience[selIndex].overLapEnabled = true;
                    if (data.excludeAdded) {
                        self.hideExclude = false;
                    }
                }
            } else{
                self.selectedFbAudience.splice(index, 1);
                if (data.excludeAdded) {
                    self.hideExclude = false;
                    var indexVal = self.selectedFbAudience.length-1;
                    self.selectedFbAudience[indexVal].excludeEnabled = true;
                }
            }
        }

        self.handleSelectDemographics = function (demographic,selectedFbAudience) {
                if (!demographic.isChecked) {
                    demographic.status = '';
                    demographic.isChecked = false;
                    var selIndex = selectedFbAudience.demographics.indexOf(demographic);
                    if (selIndex >= 0) {
                        selectedFbAudience.demographics.splice(selIndex, 1);
                    } else {
                        if (selectedFbAudience.demographics && selectedFbAudience.demographics.length > 0) {
                            if (_.find(selectedFbAudience.demographics, { id: demographic.id })) {
                                var index = _.findIndex(selectedFbAudience.demographics, { id: demographic.id });
                                selectedFbAudience.demographics.splice(index, 1);
                            }
                        }
                    }
                } else {
                    demographic.status = 'selected';
                    demographic.isChecked = true;
                    selectedFbAudience.demographics.push(demographic);
                }
        }

        self.clearSelectedData = function(item,totalList){
            _.each(totalList,function(e){
                if(e.id == item.id){
                    e.status = '';
                    e.isChecked = false;
                }
                if(e.childData && e.childData.length > 0){
                    self.clearSelectedData(item,e.childData)
                }
            })
        }

        self.removeDemographics = function (item, selectedDemographics, demographicsList) {
                var selIndex = selectedDemographics.indexOf(item);
                if (selIndex >= 0) {
                    selectedDemographics.splice(selIndex, 1);
                }
                self.clearSelectedData(item,demographicsList);
        }

        self.removeBehaviours = function (item, selectedBehaviours, behaviourList){
                var selIndex = selectedBehaviours.indexOf(item);
                if (selIndex >= 0) {
                    selectedBehaviours.splice(selIndex, 1);
                    self.clearSelectedData(item,behaviourList);
                }
        }

        self.getBehaviours = function () {
            ProductService.getBehavioursContents({clientId:self.clientId,clusterId:self.clusterId}).then(function (success) {
                if (success && success.data && success.data.length > 0) {
                    _.each(success.data, function (content) {
                        var behaviours = {};
                        behaviours.id = content.id;
                        behaviours.name = content.name;
                        behaviours.status = "";
                        behaviours.isChecked = false;
                        behaviours.isExpand = false;
                        behaviours.parentName = content.parentName;
                        behaviours.childData = content.childData;
                        behaviours.type = content.type;
                        self.behaviourList.push(behaviours);
                    });
                    _.each(self.selectedFbAudience,function(item){
                        item.behaviourList = angular.copy(self.behaviourList);
                    })
                    processBehavioursData();
                }
            }, function (error) { });
        }

        self.getDemographics = function () {
            ProductService.getDemographicsContents({clientId:self.clientId,clusterId:self.clusterId}).then(function (success) {
                if (success && success.data && success.data.length > 0) {
                    _.each(success.data, function (content) {
                        var demographics = {};
                        demographics.id = content.id;
                        demographics.name = content.name.charAt(0).toUpperCase()+content.name.replace("_"," ").slice(1);
                        demographics.status = "";
                        demographics.isChecked = false;
                        demographics.isExpand = false;
                        demographics.parentName = content.parentName;
                        demographics.childData = content.childData;
                        demographics.type = content.type;
                        self.demographicsList.push(demographics);
                    });
                    _.each(self.selectedFbAudience,function(item){
                        item.demographicsList = angular.copy(self.demographicsList);
                    })
                    processDemographicsData();
                }
            }, function (error) { });
        }

        var processBehavioursData = function(){
            _.each(self.selectedFbAudience,function(data){
                _.each(data.behaviours,function(item){
                    _.each(data.behaviourList,function(e){
                        if (e.id == item.id) {
                            e.status = 'selected';
                            e.isChecked = true;
                        }  
                        if(e.childData && e.childData.length > 0){
                            processSubBehaviours(e.childData,data.behaviours);
                        }
                    })
                })
            })
        }

        var processDemographicsData = function(){
            _.each(self.selectedFbAudience,function(data){
                _.each(data.demographics,function(item){
                    _.each(data.demographicsList,function(e){
                        if (e.id == item.id) {
                            e.status = 'selected';
                            e.isChecked = true;
                        }  
                        if(e.childData && e.childData.length > 0){
                            processSubDemographics(e.childData,data.demographics);
                        }
                    })
                })
            })
        }

        var processIntrestsData = function () {
            _.each(self.selectedFbAudience, function (data) {
                _.each(data.intrests, function (item) {
                    _.each(data.intrestsList, function (e) {
                        if (e.id == item.id) {
                            e.status = 'selected';
                            e.isChecked = true;
                        }  
                        if(e.childData && e.childData.length > 0){
                            processSubIntrests(e.childData,data.intrests);
                        }
                    })
                })
            })
        }

        var processSubIntrests = function(childData,selectedIntrests){
            _.each(selectedIntrests,function(item){
                _.each(childData,function(e){
                    if (e.id == item.id) {
                        e.status = 'selected';
                        e.isChecked = true;
                    }
                    if(e.childData && e.childData.length > 0){
                        processSubIntrests(e.childData,selectedIntrests);
                    }
                })
            })
        }

        var processSubDemographics = function(childData,selectedDemographics){
            _.each(selectedDemographics,function(item){
                _.each(childData,function(e){
                    if (e.id == item.id) {
                        e.status = 'selected';
                        e.isChecked = true;
                    }
                    if(e.childData && e.childData.length > 0){
                        processSubDemographics(e.childData,selectedDemographics);
                    }
                })
            })
        }


        var processSubBehaviours = function(childData,selectedBehaviours){
            _.each(selectedBehaviours,function(item){
                _.each(childData,function(e){
                    if (e.id == item.id) {
                        e.status = 'selected';
                        e.isChecked = true;
                    }
                    if(e.childData && e.childData.length > 0){
                        processSubBehaviours(e.childData,selectedBehaviours);
                    }
                })
            })
        }

        self.getIntrests = function () {
            ProductService.getIntrestsContent({ clientId:self.clientId,clusterId:self.clusterId}).then(function (success) {
                if (success && success.data && success.data.length > 0) {
                    _.each(success.data, function (content) {
                        var intrests = {};
                        intrests.id = content.id;
                        intrests.name = content.name;
                        intrests.status = "";
                        intrests.isChecked = false;
                        intrests.parentName = content.parentName;
                        intrests.childData = content.childData;
                        intrests.type = content.type;
                        self.intrestsList.push(intrests);
                    });
                _.each(self.selectedFbAudience,function(item){
                    item.intrestsList = angular.copy(self.intrestsList);
                })
                    processIntrestsData();
                }
            }, function (error) { });
        }

        self.handleSelectIntrests = function (intrests, selectedFbAudience) {
                if (!intrests.isChecked) {
                    intrests.status = '';
                    intrests.isChecked = false;
                    var selIndex = selectedFbAudience.intrests.indexOf(intrests);
                    if (selIndex >= 0) {
                        selectedFbAudience.intrests.splice(selIndex, 1);
                    } else {
                        if (selectedFbAudience.intrests && selectedFbAudience.intrests.length > 0) {
                            if (_.find(selectedFbAudience.intrestsList, { id: intrests.id })) {
                                var index = _.findIndex(selectedFbAudience.intrestsList, { id: intrests.id });
                                selectedFbAudience.intrests.splice(index, 1);
                            }
                        }
                    }
                } else {
                    intrests.status = 'selected';
                    intrests.isChecked = true;
                    selectedFbAudience.intrests.push(intrests);
                }
        }

        self.handleSelectBehaviours = function(behavior, selectedFbAudience){
                if (!behavior.isChecked) {
                    behavior.status = '';
                    behavior.isChecked = false;
                    var selIndex = selectedFbAudience.behaviours.indexOf(behavior);
                    if (selIndex >= 0) {
                        selectedFbAudience.behaviours.splice(selIndex, 1);
                    } else {
                        if (selectedFbAudience.behaviours && selectedFbAudience.behaviours.length > 0) {
                            if (_.find(selectedFbAudience.behaviourList, { id: behavior.id })) {
                                var index = _.findIndex(selectedFbAudience.behaviourList, { id: behavior.id });
                                selectedFbAudience.behaviours.splice(index, 1);
                            }
                        }
                    }
                } else {
                    behavior.status = 'selected';
                    behavior.isChecked = true;
                    selectedFbAudience.behaviours.push(behavior);
                }
        }

        self.removeIntrests = function (item, selectedIntrests, intrestsList) {
                var selIndex = selectedIntrests.indexOf(item);
                if (selIndex >= 0) {
                    selectedIntrests.splice(selIndex, 1);
                    self.clearSelectedData(item,intrestsList);
                }
        }

        self.setExclude = function(){
            _.each(self.selectedFbAudience,function(item){
                if(item.excludeAdded){
                    self.hideExclude = true;
                }
            })
        }

        self.initComponent = function () {
            if (self.selectedFbAudience && !_.isEmpty(self.selectedFbAudience)) {
                self.selectedFbAudience = JSON.parse(self.selectedFbAudience);
                if (self.showActions) {
                    self.editMode = true;
                    self.enableViewMode = false;
                    self.getIntrests();
                    self.getBehaviours();
                    self.getDemographics();
                    self.setExclude();
                } else {
                    self.editMode = false;
                    self.enableViewMode = true;
                }
            } else {
                self.selectedFbAudience = [{
                    intrests: [],
                    behaviours: [],
                    demographics:[],
                    overLapEnabled:true,
                    excludeEnabled:true
                    }];
                self.enableViewMode = false;
                self.getIntrests();
                self.getBehaviours();
                self.getDemographics();
            }
        };

        self.initComponent();
    }

});